import { AxiosRequestConfig } from "axios";
import api from "./api";
import { Denomination } from "./TillStats";

export interface Dto {
  q?: string;
  openDateFrom?: string;
  openDateTo?: string;
  closeDateFrom?: string;
  closeDateTo?: string;
  limit?: number;
}
export interface Session {
  id: number;
  openDate: string;
  closeDate: string;
  isPosed: boolean;
}

export interface User {
  id: number;
  userName: string;
  fullName: string;
  email: string;
}
export interface Workstation {
  id: number;
  name: string;
  macAddress: string;
  isActive: boolean;
}

export interface Till {
  id: number;
  guid: string;
  code: string;
  sess: Session;
  user: User;
  workstation: Workstation;
  Date: string;
  startTime: string;
  endTime: string;
}
const sessionId = localStorage.getItem("sessionId");
interface CustomRequestConfig extends AxiosRequestConfig {
  sessionId?: number;
}

export const getTills = async (Dto: Dto) => {
  const defaultDto: Dto = {
    q: "",
    openDateFrom: "",
    openDateTo: "",
    closeDateFrom: "",
    closeDateTo: "",
    limit: 20,
  };

  const params = { ...defaultDto, ...Dto };

  return await api.get(
    `/tills?q=${params.q}&openDateFrom=${params.openDateFrom}&openDateTo=${params.openDateTo}&closeDateFrom=${params.closeDateFrom}&closeDateTo=${params.closeDateTo}&limit=${params.limit}`
  );
};
export const getTillBySessionId = async (s?: any) => {
  return await api.get(`/tills/sessions/${s ? s : sessionId}`);
};
export const getTillStats = async (id: number) => {
  return await api.get(`/tills/${id}/stats`);
};
export const getTillDetails = async (id: number) => {
  return await api.get(`/tills/${id}/details`);
};
export const bulkAddTillDetails = async (
  id: number,
  Dto: { tillDetails: Denomination[] }
) => {
  return await api.post(`/tills/${id}/details/bulk`, Dto);
};
export const bulkEditTillDetails = async (
  id: number,
  Dto: { tillDetails: Denomination[] }
) => {
  return await api.put(`/tills/${id}/details/bulk`, Dto);
};
export const deleteTill = async (id: number, sessionId: number) => {
  return await api.delete(`/tills/${id}`, {
    sessionId,
  } as CustomRequestConfig);
};
